import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchInventory'
})
export class SearchInventoryPipe implements PipeTransform {

  transform(value: any, search: string): any {
    search = search ? search.toLowerCase() : null;
    return search ? value.filter(inv => {
        return inv.barcode.toString().toLowerCase().startsWith(search) ||
          (inv.material && inv.material.toLowerCase().startsWith(search)) ||
          (inv.location && inv.location.toLowerCase().startsWith(search)) ||
          (inv.color.name && inv.color.name.toLowerCase().startsWith(search)) ||
          (inv.color.code && inv.color.code.toLowerCase().startsWith(search)) ||
          (inv.job.name && inv.job.name.toLowerCase().startsWith(search)) ||
          (inv.job.number && inv.job.number.toLowerCase().startsWith(search))
      }) : value;
  }

}



// WEBPACK FOOTER //
// ./src/app/inventory/pipes/search-inventory-pipe.ts